import { useMemo } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { FormContextValues, useFormController } from '@dreryk/react-common';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { MedicalCertificateFormBean } from './MedicalCertificateForm.types';

export type MedicalCertificateFormController = FormContextValues<MedicalCertificateFormBean>;

type MedicalCertificateFormControllerOptions = {
   medicalCertificateDraft: MedicalCertificateFormBean | null;
};

export const useMedicalCertificateFormController = (
   options: MedicalCertificateFormControllerOptions
): MedicalCertificateFormController => {
   return useFormController<MedicalCertificateFormBean>(
      useMemo((): MedicalCertificateFormBean => {
         if (!options.medicalCertificateDraft) {
            return {
               certificateDetails: null,
               diagnoses: diagnosesWithBodySideFormPart.createBean(),
            };
         }

         return {
            certificateDetails: options.medicalCertificateDraft.certificateDetails ?? null,
            diagnoses: diagnosesWithBodySideFormPart.createBean(options.medicalCertificateDraft.diagnoses),
         };
      }, [options.medicalCertificateDraft])
   );
};

export const useDiagnosisSelectorDefaultItems = (visitDiagnoses: VisitDiagnosis[]): ICD10Disease[] => {
   return useMemo(() => {
      return visitDiagnoses.map<ICD10Disease>((diagnosis) => ({
         code: diagnosis.icd10Code,
         name: diagnosis.name,
      }));
   }, [visitDiagnoses]);
};
